import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const ElectricHeater = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path d="M.449 13.421c0 .184.149.333.333.333h10.182a.333.333 0 0 0 .333-.333V1.981c0-.846-.686-1.531-1.531-1.531H1.98C1.134.45.449 1.136.449 1.981v11.44zm.667-.334V1.98c0-.477.387-.865.865-.865h7.786c.477 0 .865.387.865.865v11.107H1.116z" />
      <path d="M6.323 2.579a.449.449 0 1 1-.898 0 .449.449 0 0 1 .898 0zM2.246 9.827c0 .184.149.333.333.333h6.589a.333.333 0 0 0 .333-.333V4.436a.333.333 0 0 0-.333-.333H2.58a.333.333 0 0 0-.333.333v5.391zm.667-.334V4.769h5.922v4.724H2.913z" />
      <path d="M2.246 8.03c0 .184.149.333.333.333h6.589a.333.333 0 1 0 0-.666H2.58a.333.333 0 0 0-.333.333zM2.246 6.233c0 .184.149.333.333.333h6.589a.333.333 0 1 0 0-.666H2.58a.333.333 0 0 0-.333.333zM1.348 15.217c0 .184.149.333.333.333h1.797a.333.333 0 0 0 .333-.333V13.42a.333.333 0 0 0-.333-.333H1.681a.333.333 0 0 0-.333.333v1.797zm.666-.333v-1.13h1.13v1.13h-1.13zm5.922.333c0 .184.149.333.333.333h1.797a.333.333 0 0 0 .333-.333V13.42a.333.333 0 0 0-.333-.333H8.269a.333.333 0 0 0-.333.333v1.797zm.667-.333v-1.13h1.13v1.13h-1.13zM4.642 13.421c0 .184.149.333.333.333h1.797a.333.333 0 0 0 .333-.333v-.898a1.232 1.232 0 1 0-2.464 0v.898zm.667-.334v-.565a.565.565 0 0 1 1.13 0v.565h-1.13zM10.632 12.223c0 .184.149.333.333.333h2.156c.846 0 1.531-.686 1.531-1.531V8.03a.333.333 0 1 0-.666 0v2.995a.865.865 0 0 1-.865.865h-2.156a.333.333 0 0 0-.333.333z" />
      <path d="M14.319 7.697a.565.565 0 0 1-.565-.565v-.565h1.13v.565a.565.565 0 0 1-.565.565zm-1.232-.566a1.233 1.233 0 0 0 2.464 0v-.898a.333.333 0 0 0-.333-.333h-1.797a.333.333 0 0 0-.333.333v.898z" />
      <path d="M14.319 6.566a.333.333 0 0 0 .333-.333V5.035a.333.333 0 1 0-.666 0v1.198c0 .184.149.333.333.333z" />
    </svg>
  );
};

ElectricHeater.category = 'product-category';

ElectricHeater.displayName = 'ElectricHeater';
